/* ==========================================================================
   Comparison Table — scroll-reveal enhancement
   Progressive enhancement: if JS is off or IntersectionObserver is missing,
   the CSS fallback below (added via this class) keeps rows visible.
   ========================================================================== */
(function () {
  "use strict";

  function reveal(section) {
    var rows = section.querySelectorAll(".ct-row--data");
    if (!rows.length) return;

    // Signal that JS is active so the CSS reveal rules apply. Without this
    // class the rows are never hidden, so no-JS visitors still see the table.
    section.classList.add("ct-js");

    // No IntersectionObserver? Just show everything.
    if (!("IntersectionObserver" in window)) {
      rows.forEach(function (row) {
        row.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    var vh = window.innerHeight || document.documentElement.clientHeight;
    rows.forEach(function (row) {
      // Rows already in view on load are revealed straight away; the observer
      // handles the rest as the visitor scrolls down to them.
      if (row.getBoundingClientRect().top < vh * 0.95) {
        row.classList.add("is-visible");
      } else {
        observer.observe(row);
      }
    });
  }

  function init() {
    document.querySelectorAll(".ct-section.ct-animate").forEach(reveal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-run when the section is (re)loaded in the Shopify theme editor.
  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector(".ct-section.ct-animate");
    if (section) reveal(section);
  });
})();
